import Pretender from 'pretender';
import { bugsnagPretender } from '@pagerduty/bugsnag-reporter';

import segmentPretender from './segment';
import feDataPretender from './fe-data';
import navbarPretender from './navbar';
import iconsPretender from './icons';
import contentfulPretender from './contenful';

export const init = () => {
  const server = new Pretender(
    feDataPretender,
    segmentPretender,
    navbarPretender,
    iconsPretender,
    contentfulPretender,
    bugsnagPretender
  );

  server.handledRequest = function handledRequest(verb, path, request) {
    console.info(`[Pretender] ${verb} ${path}`, request);
  };
};

export default init;
